import {client} from './services/client'

export  const users = {
    namespaced:true,
    state:{
        users:undefined,
        user:undefined,
        userpharmas:undefined,
        userclients:undefined
    },
    mutations: {
        SET_USER (state,users){
            state.users = users
        },
         SET_ACCOUNT (state,users){
            state.user = users
        },
        SET_PHARMA (state,users){
            state.userpharmas = users
        },
        
        SET_CLIENT (state,users){
            state.userclients = users
        },
        


    },
    actions: {
        getByType({commit},type){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/users/getbytype/'+type,
                })
                    .then((response)=>{
                        let users = response.data.users;
                        let type = response.data.type;
                        console.log("type",type);
                        console.log("users",users);
                        switch(type){
                            case "pharmacie":
                              commit('SET_PHARMA',users);
                                break;

                            case "suntechdev":
                              commit('SET_USER',users);
                                break;

                            
                            case "client":
                             commit('SET_CLIENT',users);
                                break;

                                
                        }

                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })

        },
        getUsers({commit}){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/users/get',
                })
                    .then((response)=>{
                        let users = response.data.users;
                        commit('SET_USER',users);

                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })

        },
       /* updatePassword({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/users/update/password',
                    data:data,
                }).then((response)=>{
                    resolve(response.data);
                })
                    .catch((error)=>{
                        reject(error);
                    })
            });
        },*/
        setUpdateUser({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/users/update',
                    data:data,
                })
                    .then((response)=>{
                        let users = response.data.users;
                        commit('SET_USER',users);
                        console.log("users",users);
                       // localStorage.setItem("user",JSON.stringify(users));
                        resolve(response.data);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            });
        },
        setUpdateMyAccount({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/users/update/account',
                    data:data,
                })
                    .then((response)=>{
                        let user = response.data.user;
                        commit('SET_ACCOUNT',user);
                        console.log("user",user);
                        localStorage.setItem("user",JSON.stringify(user));
                        resolve(response.data);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            });
        },
        setUser({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/users/save',
                    data:data,
                })
                    .then((response)=>{
                        let users = response.data.users;
                        commit('SET_USER',users);

                        resolve(response);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            });
        },
        deleteUser({commit},id){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/users/delete/'+id,
                })
                    .then((response)=>{
                        let users = response.data.users;
                        commit('SET_USER',users);
                    })
                    .catch((error)=>{
                        reject(error)
                    })
            })
        },
    },
    getters: {
        getUsers: state  => {
            return state.users
        },
    }
};
